import axios from "../utils/axios";

export const getAllList = (payload) => {
    return axios.get(`/${payload.table}/${payload.resourcePath}`);
};

export const updateRecord = (payload) => {
    return axios.post(`/${payload.table}/Update`, payload.data);
};

export const deleteRecord = (payload) => {
    return axios.post(`/${payload.table}/Delete`, payload.data);
};

export const addRecord = (payload) => {
    return axios.post(`/${payload.table}/Add`, payload.data);
};

export const getPlants = () => {
    return axios.get(`/Plant/GetList`);
};

export const getMailGroups = () => {
    return axios.get(`/MailGroup/GetList`);
};

export const getMailPeriods = () => {
    return axios.get(`/MailGroup/GetPeriodList`);
};

export const getBreakDownPlaceByGroupId = (payload) => {
    return axios.get(`/BreakdownReasonPlace/GetListByGroupId?breakdownGroupId=${payload}`);
};

export const getBreakDownReasonGroups = () => {
    return axios.get(`/BreakdownReasonGroup/GetList`);
};
